import MainLayout from 'components/Layout/Main'
import { getAppData, setCacheTags, setCanonical } from 'helpers/initializePage'
import CategoryLeadersMethodology from 'screens/categoryLeadersMethodology'
import { contentfulMainSiteService } from 'services/contentful'
import getapp from 'services/getapp'
import initializeExperiments from 'services/launchDarkly'

const ROUTE_NAME = 'category_leaders_methodology'

export const getServerSideProps = async ctx => {
  const contentfulService = contentfulMainSiteService({
    preview: ctx.query.preview,
    environment: ctx.req?.headers['fe-contentful-env'],
  })
  const getAppService = getapp(ctx.req)

  const [experiments, data, user] = await Promise.all([
    initializeExperiments({
      ctx,
      pageType: 'static',
    }),
    contentfulService.getCategoryLeadersMethodology().catch(() => null),
    getAppService.getUser().catch(() => null),
  ])

  const appData = { ...getAppData(ctx), experiments }
  setCanonical(ctx)

  ctx.req.APP_DATA = appData // We pass in current Request this info to Document in order to avoid double calculation.
  setCacheTags(ctx, 'static')

  return {
    props: {
      data,
      appData: {
        ...appData,
        user: user || null, // Ensure user is null instead of undefined
        route: ROUTE_NAME,
      },
    },
  }
}

CategoryLeadersMethodology.Layout = MainLayout

export default CategoryLeadersMethodology
